import request from '@/utils/request'

/**
 * 查询机构列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/unit/list',
		method: 'post',
		data: query
	})
}

/**
 * 获取机构树形结构
 * @param query
 */
export function tree(query) {
	return request({
		url: '/api/unit/tree',
		method: 'get',
		data: query
	})
}

/**
 * 保存机构
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/unit/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改机构
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/unit/update',
		method: 'post',
		data: param
	})
}

/**
 * 删除机构
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/unit/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个机构信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/unit/view/' + param,
		method: 'get'
	})
}
